import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function useDeletePrivateDriver() {
  const [loading, setLoading] = useState(false);

  async function execute(driverId: string, callback: () => void) {
    try {
      setLoading(true);
      const response = await api.delete(
        `v1/backoffice/drivers/${driverId}`,
        {},
      );

      if (callback) {
        callback();
      }

      if (response.status === 204) {
        toast.success(ToastMessages.driver.success.delete);
      }
    } catch (error: any) {
      const errorData = error.response.data;

      if (!Array.isArray(errorData.message)) {
        if (errorData.message)
          toast.error(`Erro de validação: ${errorData.message}`);
        else toast.error(ToastMessages.general.error.genericError);
      } else {
        errorData.message.map((msg: string) =>
          toast.error(`Erro de validação: ${msg}`),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
